import { Component, Input } from '@angular/core';
import { DateUtilsService } from 'app/services/date-utils.service';

@Component({
  selector: 'version-pill, indicator-chip',
  templateUrl: './version-pill.component.html',
  standalone: false
})

export class VersionPillComponent {
  @Input() label: string = 'Beta';
  @Input() type: 'pill' | 'bubble' = 'pill';
  @Input() color: 'red' | 'blue' = 'red';
  @Input() tooltipText: string = 'New';
  @Input() state: 'warning' | 'advantage' = 'warning';
  @Input() expiryDate?: string;
  @Input() contrast?: string = 'contrast';
  @Input() indicatorIcon?: boolean = false;
  @Input() chipRole?: string = 'decorative';
  @Input() skeleton?: boolean = false;
  @Input() badgeType?: string = 'info';
  @Input() infoBadgeSize?: string = 'xxs';
  @Input() infoBadgeState?: string = 'error';
  @Input() infoBadgeBorder?: boolean = false;
  @Input() notificationIcon?: boolean = false;

  constructor(private dateUtilsService: DateUtilsService) {}
  get isExpired(): boolean {
    if (!this.expiryDate) return false;
    return this.dateUtilsService.isExpired(this.expiryDate);
  }

  get shouldShow(): boolean {
    return !this.isExpired;
  }
}
